import { useState } from "react"
import { useShallow } from "zustand/react/shallow"

// components
import CommentModal from "../CommentModal/CommentModal"
import RJTableCommentContainer from "../../../components/RJTableCommentContainer/RJTableCommentContainer"

// content
import useAuthoringCommentsStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringCommentsStore"
import "./CellActions.scss"

const CellActions = ({ comment, saveComment, showActions, setShowActions, jpath, type, hideComment = false }) => {
  const [openModal, setOpenModal] = useState(false)
  const [openCommentsForm, setOpenCommentsForm] = useState(false)

  const { commentsMap } = useAuthoringCommentsStore(
    useShallow((state) => ({
      commentsMap: state.commentsMap,
    }))
  )

  let style = {
    color: "var(--prime-color-brand-icon-hover)",
    cursor: "pointer",
  }

  if (comment) {
    style = {
      ...style,
      fontWeight: "700",
    }
  }

  const jpathCell = jpath + "-cell"

  return (
    <div
      className="pf-cell-actions-container"
      id={jpathCell}
    >
      {(showActions || comment) && hideComment === false && (
        <i
          className="fal fa-info-circle"
          style={style}
          onClick={() => setOpenModal(true)}
        />
      )}
      <RJTableCommentContainer
        label={`Participant flow field`}
        jpath={jpathCell}
        openCommentsForm={openCommentsForm}
        setOpenCommentsForm={setOpenCommentsForm}
        setShowMenu={setShowActions}
        showMenu={showActions || commentsMap[jpathCell] || openCommentsForm}
        style={{ marginBottom: 2 }}
      />
      {hideComment !== true && (
        <CommentModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          saveComment={saveComment}
          selectedComment={comment}
        />
      )}
    </div>
  )
}

export default CellActions
